// @ngInject
function PsychologicalPricesApiService(ResourcesService) {

    var endpoint = 'psychologicalprices';

    return {
        getPsychologicalPrices: getPsychologicalPrices,
        getPsychologicalPrice: ResourcesService.apiFactory.get(endpoint),
        createPsychologicalPrice: ResourcesService.apiFactory.create(endpoint,'PsychologicalPriceList'),
        updatePsychologicalPrice: ResourcesService.apiFactory.update(endpoint,'PsychologicalPriceList')
    };


    function getPsychologicalPrices(page, filter, pageSize, companyId) {

        var params = {};

        if (page && page > 1) {
            params.page = page - 1;
        }

        if (pageSize && pageSize > 0) {
            params.pageSize = pageSize;
        }

        if (!_.isEmpty(filter)) {
            params.searchTerm = filter;
        }

        var args = { params: params};

        return ResourcesService.apiFactory.get(endpoint)(args);
    }

}


angular.module('psychologicalprices.api', [])
  .factory('PsychologicalPricesApiService', PsychologicalPricesApiService);
